import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CONFIRM_GENERIC_ERROR } from '@constants/cambio-via-pago-properties.constants';
import { RESPONSE_CALENDARIO_REFORMA_PENSIONES } from '@constants/tramite-pension-constant';
import { INICIO } from '@constants/url.constant';
import { IConfigReformaPensiones } from '@interfaces/config-reforma-pensiones.interface';
import { IonContent } from '@ionic/angular';
import { StorageService } from '@services/storage/storage.service';
import { IRightColumnData } from '@shared/common/interfaces/right-column-data.interface';
import { Util } from '@shared/common/utils/util';
import { GenericErrorOps } from '@shared/components/generic-error/interfaces/generic-error-ops.interface';
import { ReformaPensionesService } from '../../services/reforma-pensiones.service';

@Component({
    selector: 'app-conoce-mas-reforma',
    templateUrl: './conoce-mas-reforma.component.html',
    styleUrl: './conoce-mas-reforma.component.scss',
    standalone: false
})
export class ConoceMasReformaComponent {

  @ViewChild(IonContent, { static: false }) content: IonContent;

  showErrorScreen: boolean = false;
  rightColumnData: IRightColumnData[] = [];
  attempt: boolean = false;
  nAttempts: number = 1;
  token: string = "";
  loadingHome: boolean = true;
  servsError: boolean = false;
  public errorOps: GenericErrorOps = CONFIRM_GENERIC_ERROR;
  calendarioBeneficios: IConfigReformaPensiones = {} as IConfigReformaPensiones;

  public seccionActiva: string = 'beneficios';

  constructor(
    private readonly reformaPensionesService: ReformaPensionesService,
    private readonly util: Util,
    private readonly storageService: StorageService,
    private readonly router: Router
  ) { }

  ionViewWillEnter(): void {
    this.initializeComponent();
  }


  private initializeComponent(): void {
    this.loadingHome = true;
    void this.getCalendarioReformaPensiones();
  }

  async getCalendarioReformaPensiones() {
    try {
      this.attempt = true;
      this.token = await this.util.getIdToken();

      let response: IConfigReformaPensiones = {} as IConfigReformaPensiones;

      // Intenta obtener los beneficios desde el storage primero
      const cachedResponse = await this.storageService.get(
        RESPONSE_CALENDARIO_REFORMA_PENSIONES
      );

      if (cachedResponse) {
        response = cachedResponse;
      } else {
        response =
          await this.reformaPensionesService.getCalendarioReformaPensiones(
            this.token
          );
        await this.storageService.set(
          RESPONSE_CALENDARIO_REFORMA_PENSIONES,
          response
        );
      }

      this.calendarioBeneficios = response;

      this.loadingHome = false;
      this.servsError = false;
    } catch (error) {
      console.error(
        "Error al obtener el calendario de la reforma de pensiones",
        error
      );
      this.handleErrorState();
    }
  }

  private handleErrorState() {
    this.loadingHome = true;
    this.servsError = true;
    this.attempt = false;
  }

  onRetryEvent() {
    this.attempt = true;
    this.nAttempts++;
    if (this.nAttempts <= 3) {
      void this.getCalendarioReformaPensiones();
    } else {
      this.router.navigate([INICIO]);
    }
  }

  onGoToEvent() {
    this.router.navigate([INICIO]);
  }

  idColumnEmit(event: any) {
    this.seccionActiva = event.tabKey;
    this.content?.scrollToTop(300);
  }
}